import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FilterSet } from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-filter-set',
  templateUrl: './filter-set.component.html',
  styleUrls: ['./filter-set.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterSetComponent {
  @Input()
  filterSet: FilterSet

  public trackById = trackById
}
